<template lang="pug">
  .color-kit-info(v-if="product.id")
    .prod-info.xs-text-center.md-text-left
      h1.color-slate.upper.xs-f-xsmall.lg-f-small.max-at-tweak(data-mr-ass="selected-color-name") {{product.name}}
      h2.xs-f-large.lg-f-xxlarge.max-at-tweak(data-mr-ass="selected-color-description") {{product.short_description}}
      .stars-wrap.btn-reset.xs-f-small.lg-f-medium.max-at-tweak(@click="scrollToReviews")
        stars.inline-block(:rating="product.reviewInfo.average")
        span.color-black.underline.mr-stars-review-count {{ product.reviewInfo.count }}

    ColorKitSwatchSelector(v-if="advisorComplete")
    
    a.advisor-cta.xs-12.bg-gray-light.text-left.color-black.xs-f-small.lg-f-medium.max-at-tweak(v-if="!advisorComplete" href="/color-advisor?rectype=color" target="_self")
      | Answer a few quick questions to reveal your perfect shade
      span.icon-arrow-forward.xs-f-large.md-f-xlarge.max-at-tweak
        
    ColorKitWhyMatch(:match-type="matchType.key" :product="product")

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import ColorKitSwatchSelector from './ColorKitSwatchSelector';
  import ColorKitWhyMatch from './ColorKitWhyMatch';

  export default {
    name: "ColorKitInfo",

    components: {
      ColorKitSwatchSelector,
      ColorKitWhyMatch
    },

    props: {
      product: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        version: 'A',
        showWhyBestMatch: false
      }
    },

    computed: {
      ...mapState('customer', ['cdata']),
      ...mapState('pdp', ['tones', 'toneMap']),
      ...mapState('colorAdvisor', ['answers']),

      advisorComplete() {
        return this.$root.advisorComplete;
      },

      colorMatches() {
        return this.$root.colorMatches;
      },

      isBestMatch() {
        return this.advisorComplete && this.cdata && this.cdata.bestColorMatch && this.cdata.bestColorMatch.code == this.product.code;
      },

      matchType() {
        var type = {};
        var labelMap = {
          bestMatch: "Best Match",
          mostPopular: "Most Popular",
          customerMatch: "Your Pick",
          translatorMatch: "Translator Results",
          coloristMatch: "Colorist's Choice"
        };

        if (this.colorMatches && this.product) {
          Object.keys(this.colorMatches).forEach(key => {
            if (this.colorMatches[key] && this.colorMatches[key].code == this.product.code) {
              type.key = key;
              type.label = labelMap[key];
            }
          });
        }

        return type;
      }
    },

    methods: {
      ...mapActions('colorAdvisor', ['initAnswers']),
      ...mapActions('pdp', ['openPlaygroundModal']),

      toggleWhyBestMatch() {
        this.showWhyBestMatch = !this.showWhyBestMatch;
      },

      seeMoreColors(viewOnModel, elementRef) {
        this.openPlaygroundModal({
          props: {
            viewOnModel: viewOnModel
          },
          returnFocusElement: elementRef
        });
      },

      scrollToReviews() {
        this.$root.scrollTo('.review-wrap');
      }
    },

    mounted() {
      this.initAnswers();
    }
  }
</script>

<style scoped lang="stylus">
  .color-kit-info
    .color-matches
      padding 0.3em 0
      
      .color-match
        background-color color-slate
        border-radius 1.5em
        padding 0.25em 1em
        
    .prod-info
      padding-top 0.5em
      padding-bottom 0.75em
      
      .stars-wrap
        margin-top 0.5em
        
    .advisor-cta
      position relative
      padding 1em 1.5em
      padding-right 3.5em
      margin-top 1em
      margin-bottom 0.5em
      
      .icon-arrow-forward
        position absolute
        top 50%
        right 0.5em
        margin-top -0.75em
        
</style>
